import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import TrinethraTermsofService from '../components/compliance/TrinethraTermsofService';

const TrinethraTermsPage = () => {
  return (
    <div className='min-h-screen bg-gray-50'>
      <Header showHomeOnly={true} />
      <div className='container mx-auto py-1 px-4 top-1 mb-12 relative'>
        <h1 className='text-3xl font-bold text-center text-gray-900 mb-6'>
          Trinethra Terms of Service
        </h1>
        <div className='flex justify-center'>
          <TrinethraTermsofService />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TrinethraTermsPage;
